/**
 * Colonnes du pied de page : dépliées sur desktop, repliables sur mobile.
 *
 * Le HTML sort du serveur avec toutes les colonnes ouvertes, de sorte que le
 * pied de page reste identique à lui-même si ce script ne s'exécute pas. Le
 * composant se contente de replier sur petit écran et de re-déplier au retour
 * en desktop, où une colonne fermée n'aurait pas de sens.
 */
class MmFooterColumns extends HTMLElement {
  connectedCallback() {
    if (this.dataset.collapseMobile === 'false') return;

    this.mobile = window.matchMedia('(max-width: 749px)');
    this.columns = Array.from(this.querySelectorAll('details.mm-footer-v2__column'));

    this.applyViewport = this.applyViewport.bind(this);
    this.keepOpenOnDesktop = this.keepOpenOnDesktop.bind(this);

    this.applyViewport();
    this.mobile.addEventListener('change', this.applyViewport);
    this.addEventListener('toggle', this.keepOpenOnDesktop, true);
  }

  disconnectedCallback() {
    this.mobile?.removeEventListener('change', this.applyViewport);
    this.removeEventListener('toggle', this.keepOpenOnDesktop, true);
  }

  applyViewport() {
    const collapsed = this.mobile.matches;
    this.toggleAttribute('data-collapsed', collapsed);
    this.columns.forEach((column) => {
      column.open = !collapsed;
    });
  }

  /**
   * Sur desktop le résumé reste focusable au clavier : une pression sur Entrée
   * refermerait une colonne qui doit rester dépliée. On la ré-ouvre aussitôt.
   */
  keepOpenOnDesktop(event) {
    if (!this.mobile.matches && !event.target.open) {
      event.target.open = true;
    }
  }
}

if (!customElements.get('mm-footer-columns')) {
  customElements.define('mm-footer-columns', MmFooterColumns);
}
